import { render, staticRenderFns } from "./GGroupEdit.vue?vue&type=template&id=71203bc9&scoped=true&"
import script from "./GGroupEdit.vue?vue&type=script&lang=ts&"
export * from "./GGroupEdit.vue?vue&type=script&lang=ts&"
import style0 from "./GGroupEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GGroupEdit.vue?vue&type=style&index=1&id=71203bc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71203bc9",
  null
  
)

export default component.exports